import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';
import { AuthProvider } from "react-oidc-context";
import reportWebVitals from './reportWebVitals';


const redirectUrl = process.env.REACT_APP_REDIRECT_URL;

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_RURMc1RUf",
  client_id: "4mt9gfoklc1drhcnpgn4hilme1",
  redirect_uri: redirectUrl,
  response_type: "code",
  scope: "email openid profile",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
 
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>

);

reportWebVitals();
